import React from 'react'
import PropTypes from 'prop-types'
// import { getIn, Field } from 'formik'
import SelectRaw from '~/components/common/StarSelect'

const Select = ({ form, field, onChange, disabled, ...props }) => (
  <SelectRaw
    {...field}
    onChange={(newValue) => {
      form.setFieldValue(field.name, newValue)
      onChange(newValue)
    }}
    {...props}
    disabled={disabled || !!form.values.__readOnly}
  />
)

Select.defaultProps = {
  onChange: () => {},
  forwardOptions: (o) => o,
  disabled: false,
}

Select.propTypes = {
  onChange: PropTypes.func,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  forwardOptions: PropTypes.func,
  disabled: PropTypes.bool,
}

export default Select
